'use strict';

import { CoreRepository } from '../CoreRepository';
import { UserVoipPhoneNumber } from '../../Entities/User/UserVoipPhoneNumber';
import { UserVoipPhoneNumberCollection } from '../../Collections/User/UserVoipPhoneNumberCollection';

export class UserVoipPhoneNumberRepository extends CoreRepository {
  public createUserVoipPhoneNumbers(userId: number, payload: object = {}) {
    return this.webAPI.createUserVoipPhoneNumbers(userId, payload).then((response) => {
      return response;
    });
  }

  public getUserVoipPhoneNumbers(userId: number, provider: number, options: object = {}) {
    return this.webAPI.getUserVoipPhoneNumbers(userId, provider, options).then((response) => {
      const collection = new UserVoipPhoneNumberCollection();

      response.data.forEach((collectionItemData) => {
        const collectionItem = new UserVoipPhoneNumber();
        collectionItem.hydrate(collectionItemData);

        collection.addItem(collectionItem);
      });

      collection.setOffset(response.offset);
      collection.setLimit(response.limit);
      collection.setTotal(response.total);

      return collection;
    });
  }

  public getUserVoipPhoneNumbersApp(userId: number, app: number, options: object = {}) {
    return this.webAPI.getUserVoipPhoneNumbersApp(userId, app, options).then((response) => {
      const collection = new UserVoipPhoneNumberCollection();

      response.data.forEach((collectionItemData) => {
        const collectionItem = new UserVoipPhoneNumber();
        collectionItem.hydrate(collectionItemData);

        collection.addItem(collectionItem);
      });

      collection.setOffset(response.offset);
      collection.setLimit(response.limit);
      collection.setTotal(response.total);

      return collection;
    });
  }
}
